// extracted by mini-css-extract-plugin
export default {"empty_container":"EmptyCart_empty_container__sJz1F"};